import { CommonModule } from '@angular/common';
import { Component, effect, Input } from '@angular/core';

import { TooltipModule } from 'primeng/tooltip';
import { MultiFormatPreviewComponent } from 'src/app/@shared/components/multi-format-preview/multi-format-preview.component';
import { AttachmentService } from 'src/app/contract-management/services/attachment.service';
import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';
import { IAttachment } from 'src/app/@core/models/model';
import { ToastService } from 'src/app/@core/services/toast.service';
import { Source } from 'src/app/@shared/components/custom-components/custom-sources/custom-sources.component';
import { SourcesPanelService } from '../../../services/sources-panel.service';

@Component({
    selector: 'app-sources-panel',
    standalone: true,
    imports: [
        CommonModule,
        IconComponent,
        TooltipModule,
        MultiFormatPreviewComponent,
    ],
    templateUrl: './sources-panel.component.html',
    styleUrl: './sources-panel.component.scss'
})
export class SourcesPanelComponent {
    /** When true, heavy previews (like PDFs) should temporarily reduce work during container resizing. */
    @Input() isResizing: boolean = false;

    showDocumentPreview: boolean = false;
    selectedDocumentFile: IAttachment | null = null;
    selectedDocumentId: string | null = null;
    selectedFileName: string = '';
    isLoading: boolean = false;

    currentSource: Source | null = null;

    constructor(
        private toast: ToastService,
        public sourcesPanelService: SourcesPanelService,
        private attachmentService: AttachmentService
    ) {
        effect(() => {
            const source = this.sourcesPanelService.source();
            if (source && (source.source ?? '').toString() !== (this.currentSource?.source ?? '').toString()) {
                this.currentSource = source;
                this.openSource(source);
            }
        });
        effect(() => {
            this.showDocumentPreview = this.sourcesPanelService.isOpen();
        });
    }

    openSource(source: Source): void {
        this.isLoading = true;

        this.attachmentService.getAttachmentWithSignedUrl(source.source).subscribe({
            next: (res) => {
                if (res.success && res.data) {
                    this.selectedDocumentFile = res.data;
                    this.showDocumentPreview = true;
                    this.selectedDocumentId = res.data._id;
                    this.selectedFileName = res.data.filename;
                }
                this.isLoading = false;
            },
            error: (err) => {
                this.toast.error('Failed to load file preview: ' + err.message);
                this.isLoading = false;
            }
        });
    }

    closeDocumentPreview(): void {
        this.showDocumentPreview = false;
        this.selectedDocumentFile = null;
        this.selectedDocumentId = null;
        this.selectedFileName = '';
        this.sourcesPanelService.clearSource();
    }

}
